export const toast = {
  methods: {
    show_toast (type, title, msg, timeout) {
      toastr.options = {
        closeButton: false,
        newestOnTop: true,
        progressBar: true,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        onclick: null,
        timeOut: timeout,
        extendedTimeOut: timeout
      }
      let $toast = toastr[type](msg, title)
      this.lasttoast = $toast
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/toast.js